<!-- <app-template-select
  [disabled]="disabled"
  [value]="value"
  [control]="control"
  [disabled]="disabled"
  [required]="required"
  [options]="options"
  [multiple]="multiple"
  [label]="label"
/> -->
<app-template-search
  (onblur)="onblur.emit()"
  [disabled]="disabled"
  [value]="value"
  [control]="control"
  [disabled]="disabled"
  [required]="required"
  [options]="options"
  [multiple]="multiple"
  [label]="label"
/>
